export const getDisabledProviders = (state) => state.provider.disabledProviders;
export const getProviders = (state) => state.provider.providers;
export const getProviderLinks = (state) => state.provider.providerLinks;
export const getDeletedProviderLinks = (state) =>
  state.provider.deletedProviderLinks;
export const getProviderLinksError = (state) =>
  state.provider.providerLinksError;
export const getSelectedFilter = (state) => state.provider.selectedFilter;
